import { defineStore } from 'pinia';

export const useFooterStore = defineStore('footer', {
    state: () => ({
        footerLinks: [],
        cta: {},
        socials: null,
        androidAppUrl: null,
        appleAppUrl: null,
        footerLinks: [],
        newsletter: {}
    }),
    actions: {
        init(footer) {
            if (!footer) return
            this.footerLinks = footer.menu
            this.cta = footer.cta
            this.socials = footer.socials
            this.androidAppUrl = footer.androidAppUrl
            this.appleAppUrl = footer.appleAppUrl
            this.newsletter = footer.newsletter
            this.footerLinks = footer.links
        },
    },
});
